import apiClient from "services/apiClient";

async function addReportSettings(reportId: number, data: any) {
  const url = `/admin/reports/${reportId}/setting`;

  const res = await apiClient.post(url, data);

  return res.data;
}

export default addReportSettings;
